import { z } from "zod";

const LoginSchema = z.object({
  username: z.string().min(1, "Username is required"),
  password: z.string().min(1, "Password is required"),
  code: z.string().optional(),
  session: z.string().optional(),
});

type TLoginSchema = z.infer<typeof LoginSchema>;

export type { TLoginSchema };
export { LoginSchema };

const ForgotPasswordSchema = z
  .object({
    email: z.string().email("invalid-email"),
    code: z.string().min(1, "field-required"),
    password: z
      .string()
      .min(8, "password-at-least-8-characters")
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/, "password-invalid"),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "passwords-do-not-match",
    path: ["confirmPassword"],
  });
type TForgotPasswordSchema = z.infer<typeof ForgotPasswordSchema>;

export type { TForgotPasswordSchema };
export { ForgotPasswordSchema };

const NewPasswordSchema = z
  .object({
    email: z.string(),
    password: z
      .string()
      .min(8, "Password must be at least 8 characters")
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/, "password-invalid"),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

type TNewPasswordSchema = z.infer<typeof NewPasswordSchema>;

export type { TNewPasswordSchema };
export { NewPasswordSchema };
